import { setItem, getItem } from "../../../common/helpers/session-storage";

export default {
	data () {
		return {
			szechenyiIsVisible: false,
		};
	},
	created() {
		const stored = getItem('szechenyiVisible');
		if (stored !== undefined) {
			this.szechenyiIsVisible = stored;
		} else {
			this.szechenyiIsVisible = true;
		}
	},
	methods: {
		closeSzechenyi () {
			this.szechenyiIsVisible = false;
			setItem('szechenyiVisible', false);
		},
	},
}



// WEBPACK FOOTER //
// ../source/modules/FOO01-footer/FOO01-footer-copyright/FOO01-footer-copyright.js